import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_3 = { class: "sm:col-span-3" }
const _hoisted_4 = {
  for: "filter_status",
  class: "block text-sm font-medium text-gray-800"
}
const _hoisted_5 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4" }

import { computed, Ref, ref, watch } from 'vue';
import store from '@/store';

import { FilterIcon } from '@heroicons/vue/solid';
import {
    MultiSelectOption,
    IntegrationLogFilter,
    IntegrationLogGetters,
    IntegrationLogActions,
} from '@/types';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'IntegrationLogListFilters',
  setup(__props) {

const filterOpened = ref(false);

const defaultFilter = computed(() => store.getters[IntegrationLogGetters.DEFAULT_FILTER]);

const filter: Ref<IntegrationLogFilter> = ref({
    status: defaultFilter.value.status,
});

const storeFilter = computed(() => store.getters[IntegrationLogGetters.FILTER]);

const { t } = useI18n();

const statusFilterOptions = [
    {
        label: t('integration.logs.filters.status.options.ok'),
        value: 'ok',
    },
    {
        label: t('integration.logs.filters.status.options.nok'),
        value: 'nok',
    },
] as MultiSelectOption[];

function applyFilters() {
    store.dispatch(IntegrationLogActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(IntegrationLogActions.CLEAR_FILTER);
    refreshLocalFilter();
}
function refreshLocalFilter() {
    filter.value.status = storeFilter.value.status;
}

watch(filterOpened, () => {
    refreshLocalFilter();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filterOpened.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-3 h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('integration.logs.filters.status.label')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "filter_status",
              modelValue: filter.value.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.status) = $event)),
              options: statusFilterOptions,
              placeholder: _unref(t)('core.options.All'),
              "can-clear": ""
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})